var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import muiTypography from '@customink/design-tokens/build/ci_light/js/typography.mui';
var themeOptions = function (theme) { return ({
    components: {
        MuiTooltip: {
            defaultProps: {
                arrow: true,
                enterTouchDelay: 0,
                placement: 'bottom',
            },
            styleOverrides: {
                arrow: {
                    color: designTokens.color.gray.slateDark.value,
                },
                tooltip: __assign(__assign({}, muiTypography.uiTextSmall), { backgroundColor: designTokens.color.gray.slateDark.value, padding: theme.spacing(1, 2, 1.25, 2), borderRadius: theme.spacing(0.25) }),
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=tooltipTheme.js.map